import React, { useState, useEffect } from "react";
import {
  Container,
  Card,
  Table,
  Pagination,
} from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom";
import { getUsers } from "../../store/slices/user";
import { useDispatch, useSelector } from "react-redux";

export default function AdminwalletDetails() {
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const { users, pagination } = useSelector(
    (state) => state.user
  );
  const [page, setPage] = useState(1);
  const [limit] = useState(20);

  useEffect(() => {
    dispatch(getUsers({ page, limit }));
  }, [dispatch, page, limit]);

  const totalPages = pagination?.totalPages || 1;

  const buildPages = () => {
    if (totalPages <= 6) return Array.from({ length: totalPages }, (_, i) => i + 1);
    const pages = [];
    if (page > 3) { pages.push(1); if (page > 4) pages.push("..."); }
    for (let i = Math.max(1, page - 1); i <= Math.min(totalPages, page + 1); i++) pages.push(i);
    if (page < totalPages - 2) { if (page < totalPages - 3) pages.push("..."); pages.push(totalPages); }
    return pages;
  };

  const handleEdit = (id) => {
    navigate(`/admin/user-wallet/${id}`);
  };

  return (

    <>
      <div className="breadcrumb-bar mx-1" >
        <div className="container-fluid">
          <div className="d-flex  flex-row align-items-center justify-content-between gap-2 py-2">
            <div className="breadcrumb-left d-flex align-items-center flex-wrap">
              <Link to="/admin/home" className="breadcrumb-link active my-2">
                Home
              </Link>

              <span className="breadcrumb-separator mx-2">
                <i className="bi bi-chevron-right"></i>
              </span>

              <span
                className="breadcrumb-link inactive"

              >
                Wallet
              </span>

            </div>


          </div>
        </div>
      </div>



      <div className="ud-page-wrap">
        <Container fluid>

          <div className="ud-header">
            <h2 className="ud-main-title">Wallet</h2>

          </div>

          <Card className="ud-table-card">

            <Card.Body className="p-0">

              <div className="ud-scroll-wrap">

                <Table
                  hover
                  borderless
                  className="ud-table align-middle mb-0"
                >

                  <thead>

                    <tr>
                      <th>#</th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Mobile</th>
                      <th>Referral Code</th>
                      <th>Action</th>
                    </tr>

                  </thead>

                  <tbody>

                    {users.map((user, idx) => (

                      <tr key={user._id}>
                        <td>{(page - 1) * limit + idx + 1}</td>
                        <td>
                          <div className="ud-user-cell">

                            <span className="ud-user-name">{user.name}</span>
                          </div>
                        </td>
                        <td className="ud-email">{user.email}</td>
                        <td>{user.mobileNumber}</td>
                        <td>
                          <span className="ud-ref-badge">{user.referralCode}</span>
                        </td>


                        <td className="d-flex justify-content-center align-items-center" >

                          <button

                            className="global-login-btn px-2 py-1" onClick={() =>
                              handleEdit(
                                user._id
                              )
                            }
                          >

                            View Wallet
                          </button>

                        </td>

                      </tr>

                    ))}

                  </tbody>

                </Table>

              </div>

            </Card.Body>

          </Card>

          {/* pagination */}

          <div className="ud-pagination-wrap">

            <Pagination className="ud-pagination mb-5">

              <Pagination.Prev
                disabled={page === 1}
                onClick={() => setPage(page - 1)}
              />

              {buildPages().map((p) => (

                <Pagination.Item
                  key={p}
                  active={page === p}
                  onClick={() => setPage(p)}
                >
                  {p}
                </Pagination.Item>

              ))}

              <Pagination.Next
                disabled={page === totalPages}
                onClick={() => setPage(page + 1)}
              />

            </Pagination>

          </div>

        </Container>

      </div>
    </>

  );
}